import { useCallback, useEffect } from 'react'
import { trackGAEvent } from '@moonpig/web-core-analytics'
import {
  createProductItemGAEvent,
  createViewItemListGAEvent,
  ProductItemEventEnum,
} from '@moonpig/web-shared-products'
import {
  ProductMessageItem,
  ProductsMessageContent,
} from '../ChatMessages/types'
import { useChatModeContext } from '../ChatContext'

const getProductListLabel = (title?: string) =>
  `ai concierge | ${title || 'recommendations'} | carousel`

export const useProductsMessageTracking = ({
  productsContent,
  messageId,
}: {
  productsContent: ProductsMessageContent
  messageId: number
}) => {
  const { trackedCarouselMessageIds } = useChatModeContext()
  const products = productsContent.items
  const productListLabel = getProductListLabel(productsContent.title)

  useEffect(() => {
    if (!products.length || trackedCarouselMessageIds.current.has(messageId)) {
      return
    }

    trackedCarouselMessageIds.current.add(messageId)
    trackGAEvent(
      createViewItemListGAEvent({
        products,
        label: productListLabel,
      }),
    )
  }, [messageId, productListLabel, products, trackedCarouselMessageIds])

  return useCallback(
    (item: ProductMessageItem) => {
      const selectedProductIndex = products.indexOf(item)

      trackGAEvent(
        createProductItemGAEvent({
          eventType: ProductItemEventEnum.SELECT_ITEM,
          product: item,
          index: selectedProductIndex,
          label: `${productListLabel} | ${selectedProductIndex + 1}/${
            products.length
          }`,
          listName: productListLabel,
          variant: item.masterVariant.title,
        }),
      )
    },
    [productListLabel, products],
  )
}
